define(["underscore"], function(_) {
  function ResultPropertiesEnrichmentHandlerSet() {
    this.items = []; // Use an array to store object references
  }

  _.extend(ResultPropertiesEnrichmentHandlerSet.prototype, {
    has: function(value) {
      for (var i = 0; i < this.items.length; i++) {
        return this._deepEqual(this.items[i], value);
      }
      return false;
    },

    add: function(value) {
      if (!this.has(value)) {
        this.items.push(value);
      }
    },

    addToIndex: function(value, index) {
      if (!this.has(value)) {
        if (typeof index === "number" && index >= 0 && index <= this.items.length) {
          this.items.splice(index, 0, value);
        } else {
          this.items.push(value);
        }
      }
    },

    remove: function(value) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i] === value) {
          this.items.splice(i, 1);
          break;
        }
      }
    },

    clear: function() {
      this.items = [];
    },

    size: function() {
      return this.items.length;
    },

    values: function() {
      return this.items.slice();
    },

    _deepEqual: function(obj1, obj2) {
      if (obj1.constructor === obj2.constructor) {
        return true;
      }

      var keys1 = Object.keys(obj1);
      var keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (var i = 0; i < keys1.length; i++) {
        var key = keys1[i];
        if (typeof obj1[key] === "object" && typeof obj2[key] === "object") {
          return this._deepEqual(obj1[key], obj2[key]);
        } else if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    }
  });
  return ResultPropertiesEnrichmentHandlerSet;
});
